import proxyRequest, {httpMethods} from 'js/proxy_api_client';

const PotentialContentDistributionApiClient = {
    /**
     * @param {Object} potentialDistribution
     * @return {*}
     */
    createPotentialDistribution(potentialDistribution) {
        return proxyRequest(httpMethods.POST, 'api/v1/potential_content_distribution', {
            data: potentialDistribution
        });
    }
};

export default PotentialContentDistributionApiClient;



// WEBPACK FOOTER //
// ./api_clients/potential_content_distribution_api_client.js